import { useState, useEffect } from "react";
import * as anchor from "@project-serum/anchor";
import {
  Box,
  Button,
  VStack,
  SimpleGrid,
  Text,
  Center,
} from "@chakra-ui/react";

import { getMonsterFromWallet, fetchMonsterAbility } from "./MonsterProgram";
import { useWallet, useAnchorWallet } from "@solana/wallet-adapter-react";
import {
  Monster,
  Ability as AbilityType,
  teachMonsterAbility,
} from "./MonsterProgram";

import { MonsterProfile } from "./Home";

export interface AbilityProps {
  connection: anchor.web3.Connection;
}

interface AvailableMove {
  name: string;
  attack: number;
  manaCost: number;
  cooldown: number;
  levelRequirement: number;
  children?: JSX.Element;
}

const AvailableAbilities: Array<AvailableMove> = [
  {
    name: "Pound",
    attack: 2,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
  {
    name: "Fira",
    attack: 3,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
  {
    name: "Shadow Blast",
    attack: 3,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
  {
    name: "Soul Whip",
    attack: 3,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
  {
    name: "Stomp",
    attack: 2,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
  {
    name: "Frost Surge",
    attack: 3,
    manaCost: 0,
    cooldown: 0,
    levelRequirement: 1,
  },
];

const AbilityCard = (props: AvailableMove) => {
  return (
    <VStack m={8} p="4" fontSize="0.8em" border="3px solid">
      <Text>{props.name}</Text>
      <Text>Attack: {props.attack}</Text>
      <Text>Mana Cost: {props.manaCost}</Text>
      <Text>Cooldown: {props.cooldown}</Text>
      <Text>Level Req: {props.levelRequirement}</Text>
      {props.children}
    </VStack>
  );
};

interface AbilityDisplayProps {
  abilitySlot: number;
  connection: anchor.web3.Connection;
}

const Ability = (props: AbilityProps) => {
  const wallet = useWallet();
  const anchorWallet = useAnchorWallet();

  const [monster, setMonster] = useState<Monster>();
  const [moveChanged, setMoveChanged] = useState<number>();

  const AbilityDisplay = (props: AbilityDisplayProps) => {
    const [ability, setAbility] = useState<AbilityType>();

    useEffect(() => {
      async function getAbility() {
        let ability = await fetchMonsterAbility(
          anchorWallet as anchor.Wallet,
          props.connection,
          props.abilitySlot
        );
        setAbility(ability);
      }

      getAbility();
    }, [props.connection, props.abilitySlot]);

    if (!ability) {
      return (
        <Button onClick={() => setMoveChanged(props.abilitySlot)}>
          Teach Ability
        </Button>
      );
    }

    return <Box>{ability.name}</Box>;
  };

  const DisplayMonsterMoves = () => {
    return (
      <Box>
        <Text>Current Abilities</Text>
        <VStack>
          <AbilityDisplay connection={props.connection} abilitySlot={1} />
          <AbilityDisplay connection={props.connection} abilitySlot={2} />
          <AbilityDisplay connection={props.connection} abilitySlot={3} />
          <AbilityDisplay connection={props.connection} abilitySlot={4} />
        </VStack>
      </Box>
    );
  };

  useEffect(() => {
    (async () => {
      if (anchorWallet.publicKey) {
        let monster = await getMonsterFromWallet(
          anchorWallet as anchor.Wallet,
          props.connection
        );

        setMonster(monster);
      }
    })();
  }, [anchorWallet, props.connection]);

  return (
    <Box>
      <Center>
        {monster && <MonsterProfile {...monster} />}
        {monster && <DisplayMonsterMoves />}
        {/* {monster && <MonsterAbilityDisplay monster={monster} connection={props.connection} anchorWallet={anchorWallet}/>} */}
      </Center>

      {moveChanged && (
        <Box mt={8} bg="black" color="white" h="100vh">
          <Center>
            <Text>You are modifying move: {moveChanged}</Text>
          </Center>
          <SimpleGrid columns={6}>
            {AvailableAbilities.map((ability, idx) => (
              <AbilityCard {...ability} key={idx}>
                <Button
                  fontSize="0.8em"
                  onClick={() =>
                    teachMonsterAbility(
                      anchorWallet as anchor.Wallet,
                      props.connection,
                      moveChanged,
                      idx
                    )
                  }
                >
                  Teach Move
                </Button>
              </AbilityCard>
            ))}
          </SimpleGrid>
        </Box>
      )}
    </Box>
  );
};

export default Ability;
